import React, { ReactNode, ComponentType } from 'react';
import { Tabs } from 'antd';
import { useLocation, Link } from 'react-router-dom';
import PipelineList from '../Pipelines/PipelineList';
import AIProcessorList from '../../AIProcessors/AIProcessorList';
import LLMModelsList from '../../LLMModels/LLMModelsList';
import DocumentList from '../Documents/DocumentList';
import AIIntegrationList from "@src/components/AIIntegration/AIIntegrationList";
import { getIconDashboard, getIconDocument, getIconLLMModel, getIconPipeline, getIconProcessor } from "@src/components/AIIntegration/utils";
import { ListProps, useGetIdentity } from "react-admin";
import useGetGeneralSettings from "@src/providers/useGetGeneralSettings";
import './PackDashboard.css';

export interface TabConfig {
    label: string;
    value: string;
    icon: ReactNode;
    component: ComponentType<ListProps>;
    route: string;
}

interface PackDashboardTabsProps {
    activeKey?: string;
    onChange?: (activeKey: string) => void;
    renderContent?: boolean;
}

export const useTabsConfig = () => {
    const { identity } = useGetIdentity();
    const generalSettings = useGetGeneralSettings();
    const AIIntegrationSettings = generalSettings.find(setting => setting.name == 'AIIntegration');
    const tabsConfig: TabConfig[] = []

    if (AIIntegrationSettings?.config?.show_ai_processor)
        tabsConfig.push(
            {
                label: 'Pipelines',
                value: 'Pipelines',
                icon: getIconPipeline(),
                component: PipelineList,
                route: 'serviceowner_pack_pipelines',
            },
            {
                label: 'AI Processors',
                value: 'AIProcessors',
                icon: getIconProcessor(),
                component: AIProcessorList,
                route: 'serviceowner_ai_processors',
            },
            {
                label: 'Documents',
                value: 'Documents',
                icon: getIconDocument(),
                component: DocumentList,
                route: 'serviceowner_pack_documents',
            },
        );

    if (identity?.is_superuser)
        tabsConfig.push(
            {
                label: 'LLM Models',
                value: 'LLMModels',
                icon: getIconLLMModel(),
                component: LLMModelsList,
                route: 'llm_models',
            },
        );
    tabsConfig.push(
        {
            label: 'Analytics',
            value: 'Analytics',
            icon: getIconDashboard(),
            component: AIIntegrationList,
            route: 'serviceowner_pack_statistics',
        }
    )

    return tabsConfig;
};

const PackDashboardTabs: React.FC<PackDashboardTabsProps> = ({
    activeKey,
    onChange,
    renderContent = false
}) => {
    console.log("activeKey", activeKey);
    const location = useLocation();
    const tabsConfig = useTabsConfig();

    const currentResource = location.pathname.split('/')[1];
    const currentTab = tabsConfig.find(tab => tab.route === currentResource);
    const activeTabKey = activeKey || currentTab?.value || tabsConfig[0].value;
    console.log("activeTabKey", activeTabKey)

    const handleTabChange = (key: string) => {
        // const tab = tabsConfig.find(t => t.value === key);
        // if (tab) {
        //     if (onChange) {
        //         onChange(key);
        //     } else {
        //         window.history.replaceState(null, '', `#/${tab.route}`);
        //         window.location.hash = `#/${tab.route}`;
        //     }
        // }
    };

    return (
        <Tabs
            activeKey={activeTabKey}
            onChange={handleTabChange}
            className="pack-dashboard-tabs"
            items={tabsConfig.map((tab) => ({
                key: tab.value,
                label: (
                    <Link to={`/${tab.route}`} style={{ textDecoration: 'none', color: 'inherit', display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <span style={{ display: 'flex', alignItems: 'center' }}>{tab.icon}</span>
                        <span>{tab.label}</span>
                    </Link>
                ),
                children: renderContent ? <tab.component resource={tab.route} basePath={tab.route} /> : undefined,
            }))}
        />
    );
};

export default PackDashboardTabs;